import { useState, useContext } from 'react';
import { Formik } from 'formik';
import { DatePicker, FilterModal, SelectSearch } from 'components';
import { DateConvert } from 'utilities';
import { DropdownContext } from '../context/DropdownContext';

export const ModalFilterPage = ({ toggle, data, setData }) => {
  const [loading, setLoading] = useState(false);
  const { dropdownUpah, dropdownVendor } = useContext(DropdownContext);
  const option = { label: 'Semua Data', value: undefined };
  const optionUpah = [option].concat(dropdownUpah?.data ?? []);
  const optionVendor = [option].concat(dropdownVendor?.data ?? []);

  const formInitialValues = {
    tgl_transfer_work_order_upah_mulai: data.tgl_transfer_work_order_upah_mulai,
    tgl_transfer_work_order_upah_selesai:
      data.tgl_transfer_work_order_upah_selesai,

    tgl_permintaan_work_order_upah_mulai:
      data.tgl_permintaan_work_order_upah_mulai,
    tgl_permintaan_work_order_upah_selesai:
      data.tgl_permintaan_work_order_upah_selesai,

    id_item_upah: data.id_item_upah,
    id_vendor: data.id_vendor,
  };
  const formSubmitHandler = (values) => {
    const checkActive =
      !!Object.values(values).filter((val) => val !== undefined).length > 0;

    setData({
      ...data,
      ...values,
      active: checkActive,
      page: 1,
    });

    toggle();
  };

  const onResetButtonClick = (setValues) => {
    setLoading(true);

    const myPromise = new Promise((resolve) => {
      setValues({
        tgl_transfer_work_order_upah_mulai: undefined,
        tgl_transfer_work_order_upah_selesai: undefined,
        tgl_permintaan_work_order_upah_mulai: undefined,
        tgl_permintaan_work_order_upah_selesai: undefined,
        id_item_upah: undefined,
        id_vendor: undefined,
      });

      setTimeout(() => resolve(), 300);
    });

    myPromise.then(() => setLoading(false));
  };

  const onTanggalChange = (
    dates,
    values,
    setValues,
    value_mulai,
    value_selesai,
  ) => {
    const [start, end] = dates;
    const startDate = start ? DateConvert(start).default : null;
    const endDate = end ? DateConvert(end).default : null;

    setValues({
      ...values,
      [value_mulai]: startDate,
      [value_selesai]: endDate,
    });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={formInitialValues}
      onSubmit={formSubmitHandler}
    >
      {({ values, handleSubmit, setFieldValue, setValues }) => (
        <FilterModal
          isToggle
          toggleModal={toggle}
          onResetButtonClick={() => onResetButtonClick(setValues)}
          onFilterButtonClick={handleSubmit}
        >
          <DatePicker
            selectsRange
            monthsShown={2}
            label="Tgl. Transfer Upah Work Order"
            placeholderText="Pilih Tanggal Transfer Upah Work Order"
            startDate={
              values?.tgl_transfer_work_order_upah_mulai
                ? new Date(values?.tgl_transfer_work_order_upah_mulai)
                : ''
            }
            endDate={
              values?.tgl_transfer_work_order_upah_selesai
                ? new Date(values?.tgl_transfer_work_order_upah_selesai)
                : ''
            }
            onChange={(dates) =>
              onTanggalChange(
                dates,
                values,
                setValues,
                'tgl_transfer_work_order_upah_mulai',
                'tgl_transfer_work_order_upah_selesai',
              )
            }
          />

          <DatePicker
            selectsRange
            label="Tgl. Permintaan Work Order"
            placeholderText="Pilih Tanggal Permintaan Produksi"
            startDate={
              values?.tgl_permintaan_work_order_upah_mulai
                ? new Date(values?.tgl_permintaan_work_order_upah_mulai)
                : ''
            }
            endDate={
              values?.tgl_permintaan_work_order_upah_selesai
                ? new Date(values?.tgl_permintaan_work_order_upah_selesai)
                : ''
            }
            onChange={(dates) =>
              onTanggalChange(
                dates,
                values,
                setValues,
                'tgl_permintaan_work_order_upah_mulai',
                'tgl_permintaan_work_order_upah_selesai',
              )
            }
            monthsShown={2}
          />

          <SelectSearch
            key="1"
            label="Item Upah"
            placeholder="Pilih Item Upah"
            defaultValue={optionUpah?.find(
              (val) => val.value === values.id_item_upah,
            )}
            option={optionUpah}
            onChange={(val) => setFieldValue('id_item_upah', val.value)}
            loading={dropdownUpah?.isLoading || loading}
          />

          <SelectSearch
            key="2"
            label="Vendor"
            placeholder="Pilih Vendor"
            defaultValue={optionVendor?.find(
              (val) => val.value === values.id_vendor,
            )}
            option={optionVendor}
            onChange={(val) => setFieldValue('id_vendor', val.value)}
            loading={dropdownUpah?.isLoading || loading}
          />
        </FilterModal>
      )}
    </Formik>
  );
};
